<template>
    <div class="pop" :class="classObj">
        <van-popup v-model="show" @click-overlay="close">
            <div class="content">
                <div class="title">{{ $t('playGameByDeposit.title') }}</div>
                <div class="desc">{{ $t('playGameByDeposit.desc') }}</div>
                <div class="actions">
                    <div class="btn btn--primary" @click="toDeposit">{{ $t('playGameByDeposit.activateNow') }}</div>
                    <div class="btn btn--ghost" @click="close">{{ $t('playGameByDeposit.reject') }}</div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    computed: {
        ...mapState({
            device: state => state.app.device
        }),
        classObj() {
            return {
                mobile: this.device === 'mobile'
            }
        },
        show: {
            get() {
                return this.$store.getters.isShowPlayGamePopup
            },
            set(val) {
                return val
            }
        }
    },
    methods: {
        close() {
            this.$store.dispatch('system/setIsShowPlayGamePopup', false)
        },
        toDeposit() {
            if (this.$route.path.indexOf('/wallet') !== -1) {
                return
            }
            const params = { type: 'deposit' }
            this.onNavTo({ url: '/wallet', type: 'get', params })
            this.close()
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';

.pop {
    text-align: left;

    &.mobile {
        .content {
            .body {
                .desc_txt {
                    &>div:first-child {
                        font-size: .45rem;
                        padding: 0;
                    }
                }
            }
        }
    }

    .van-popup {
        border-radius: .32rem;
        width: 88vw;
        max-width: 6.8rem;
        max-height: 88vh;
        height: auto !important;
        background: transparent;
        overflow: hidden;
        background: $bg-popup-color;
    }

    .content {
        width: 100%;
        height: 100%;
        position: relative;
        padding: .58rem .38rem;
        overflow: hidden;

        .title {
            font-size: .34rem;
            line-height: 1.35;
            color: $font-color;
            font-weight: 700;
        }

        .desc {
            margin-top: .24rem;
            color: rgba($font-title-color, .86);
            font-size: .26rem;
            line-height: .4rem;
        }

        .actions {
            margin-top: .34rem;
            display: flex;
            flex-direction: column;
            gap: .18rem;
        }

        .btn {
            height: .82rem;
            border-radius: .18rem;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: .28rem;
            font-weight: 700;
            cursor: pointer;
            user-select: none;
            margin: 0 .38rem;
        }

        .btn--primary {
            color: $font-color;
            background:
                linear-gradient(180deg, rgba($font-title-color, .16) 0%, rgba($font-title-color, 0) .14rem),
                $bg-component-highlight-color;
            box-shadow: 0 .12rem .24rem rgba($bg-shell-color, .18);
        }

        .btn--ghost {
            color: $font-component-surface-soft-color;
            background: $bg-component-deep-color;
            border: 1px solid $border-component-soft-color;
        }
    }
}
</style>
